
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trade/apply",
      function () {
        return require("private-next-pages/trade/apply.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trade/apply"])
      });
    }
  